import { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import { getUserData } from '../../actions/auth';
import { getProgress } from '../../actions/menus';
import ImportantNote from './ImportantNote';
import progressVideo from '../../assets/videos/progress.webm';
import styles from './ProgressPage.module.css';

const progressPoints = [
  {
    title: 'Analysing your profile',
    points: 0,
  },
  {
    title: 'Estimating your daily kcal plan',
    points: 25,
  },
  {
    title: 'Finding best recipes for you...',
    points: 50,
  },
  {
    title: 'Final review',
    points: 75,
  },
];

const ProgressPage = (props) => {
  const { 
    progressData,
    getProgress,
    getUserData,
  } = props;

  const [showStrict, setShowStrict] = useState(false);

  console.log('===RENDER', showStrict);

  const intervalRef = useRef(null);

  useEffect(() => {
    getProgress();
    intervalRef.current = setInterval(() => {
      // console.log('===HELLO');
      getProgress();
    }, 3000);

    return () => clearInterval(intervalRef.current);
  }, []);

  useEffect(() => {
    if (progressData?.failed) {
      clearInterval(intervalRef.current);
      return setShowStrict(true);
    }

    if (progressData?.progress === 100) {
      clearInterval(intervalRef.current);
      getUserData();
    }
  }, [progressData]);

  if (!progressData) {
    return null;
  }

  if (showStrict) {
    return (
      <ImportantNote message="Your progress has failed. Please try again." />
    );
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.header}>
          Creating your meal plan...
          <video 
            className={styles.video} 
            autoPlay
            muted
            loop
            playsInline
          >
            <source
              src={progressVideo}
              type="video/webm"
            />
            Your browser does not support the video tag.
          </video>
        </div>
        <div className={styles.progressContent}>
          <div className={styles.progressBar}>
            <div className={styles.progressText}>
              {progressData.progress}%
            </div>
            <progress
              max="100"
              value={progressData.progress}
              className={cn(styles.progress, 'progress-bar')}
            />
          </div>
        </div>
        <div className={styles.progressPoints}>
          {progressPoints.map((point, index) => (
            <div 
              key={index} 
              className={cn(styles.progressPoint, { [styles.active]: point.points <= progressData.progress })}
            >
              {point.title}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  progressData: state.menus.progressData,
});

const mapDispatchToProps = {
  getProgress,
  getUserData,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProgressPage);
